module.exports = __webpack_public_path__ + "static/img/LK@2x.14d2b058.jpg";